/* VAEL Maison — storefront behaviours, part 3 */
(() => {
  'use strict';
  const { CFG, $, $$, store, once, toast, initReveal, initHero, initCarousels, initTabs, wl, wlToggle, syncWishlistUI, fetchCard, renderHandles, initWishlistPage, addToCart, initMember, openModal, initSizeTables, initMenuTags, initLooks, initPress } = window.__VAEL;

  /* ---------------- product page: siblings, complete the look, recently viewed, notify ---------------- */
  async function searchJSON(q, limit = 12) {
    const r = await fetch('/search?type=product&view=vael-json&q=' + encodeURIComponent(q), { credentials: 'same-origin' });
    if (!r.ok) return [];
    try { return (await r.json()).slice(0, limit); } catch (e) { return []; }
  }
  async function initSiblings(root = document) {
    $$('[data-vael-siblings]', root).forEach(async (el) => {
      if (!once(el, 'vsb')) return;
      const group = el.dataset.group, current = el.dataset.current;
      if (!group) return;
      const res = await searchJSON('tag:"' + group + '"', 16);
      const list = res.filter((p) => p.tags && p.tags.includes(group));
      if (list.length < 2) return;
      const wrap = $('.vael-siblings__list', el);
      wrap.innerHTML = list.map((p) => '<a href="' + p.url + '" class="vael-sibling' + (p.handle === current ? ' is-current' : '') + '" title="' + p.color + '" aria-label="' + p.color + '">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" width="112" height="150">' : '') + '</a>').join('');
      el.hidden = false;
    });
  }
  async function initCompleteLook(root = document) {
    $$('[data-vael-ctl]', root).forEach(async (sec) => {
      if (!once(sec, 'vct')) return;
      const grid = $('[data-ctl-grid]', sec);
      let handles = (sec.dataset.handles || '').split(',').filter(Boolean);
      if (!handles.length && sec.dataset.query) {
        const exclude = (sec.dataset.exclude || '').split(',').filter(Boolean);
        const needTags = (sec.dataset.require || '').split('|').filter(Boolean);
        const res = await searchJSON(sec.dataset.query, 48);
        handles = res.filter((p) => p.available !== false && needTags.every((t) => p.tags.includes(t)) && !exclude.some((g) => p.tags.includes(g)) && p.handle !== sec.dataset.current).map((p) => p.handle).slice(0, parseInt(sec.dataset.limit, 10) || 4);
      }
      if (!handles.length) return;
      const n = await renderHandles(grid, handles);
      if (n) { sec.hidden = false; initReveal(sec); }
    });
  }
  const RV_KEY = 'vael:recent';
  function trackRecent() {
    if (CFG.template !== 'product' || !CFG.productHandle) return;
    const list = store.get(RV_KEY, []).filter((h) => h !== CFG.productHandle);
    list.unshift(CFG.productHandle);
    store.set(RV_KEY, list.slice(0, 16));
  }
  async function initRecent(root = document) {
    $$('[data-vael-recent]', root).forEach(async (sec) => {
      if (!once(sec, 'vrc')) return;
      const max = parseInt(sec.dataset.limit, 10) || 8;
      const list = store.get(RV_KEY, []).filter((h) => h !== CFG.productHandle).slice(0, max);
      if (!list.length) return;
      const track = $('.vael-track', sec);
      const n = await renderHandles(track, list);
      if (n) { sec.hidden = false; initCarousels(sec); }
    });
  }
  function initNotify(root = document) {
    $$('[data-vael-notify]', root).forEach((box) => {
      if (!once(box, 'vn')) return;
      const section = box.closest('.shopify-section') || document;
      const getBtn = () => section.querySelector('button[name="add"], .add-to-cart-button, [ref="addToCartButton"]');
      const check = () => { const b = getBtn(); box.classList.toggle('is-visible', !!(b && b.disabled)); };
      const target = section.querySelector('product-form-component, form[action*="/cart/add"]') || section;
      new MutationObserver(check).observe(target, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
      check();
      const form = $('form', box);
      form && form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const email = $('input[type=email]', form).value.trim();
        const vid = (section.querySelector('input[name="id"]') || {}).value || box.dataset.variant;
        const msg = $('[data-notify-msg]', box);
        try {
          if (CFG.klaviyoKey) {
            await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + encodeURIComponent(CFG.klaviyoKey), {
              method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
              body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email } } } }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } } } })
            });
          } else {
            const fd = new FormData();
            fd.append('form_type', 'contact'); fd.append('utf8', '✓');
            fd.append('contact[email]', email);
            fd.append('contact[body]', 'Stok bildirimi talebi — ' + document.title + ' — varyant ' + vid + ' — ' + location.href);
            await fetch('/contact', { method: 'POST', body: fd });
          }
          if (msg) msg.textContent = 'Teşekkürler! Ürün stoğa girdiğinde size haber vereceğiz.';
          form.hidden = true;
        } catch (err) { if (msg) msg.textContent = 'Bir sorun oluştu, lütfen tekrar deneyin.'; }
      });
    });
  }

  /* ---------------- collection: grid promo + load more ---------------- */
  function initGridPromo() {
    const tpl = $('template[data-vael-grid-promo]');
    if (!tpl) return;
    const pos = Math.max(1, parseInt(tpl.dataset.position, 10) || 6);
    const place = () => {
      const grid = $('.product-grid');
      if (!grid || grid.querySelector('.vael-grid-promo-item')) return;
      const items = grid.querySelectorAll(':scope > li');
      if (items.length < pos) return;
      const li = document.createElement('li');
      li.className = 'product-grid__item vael-grid-promo-item';
      li.style.gridRow = 'span ' + (tpl.dataset.rows || 1);
      li.appendChild(tpl.content.cloneNode(true));
      items[pos - 1].after(li);
    };
    place();
    const target = $('.product-grid') && $('.product-grid').parentElement;
    target && new MutationObserver(place).observe(target, { childList: true, subtree: true });
  }
  function initLoadMore() {
    const status = $('[data-vael-load-more]');
    if (!status) return;
    const pag = () => $('.pagination');
    const nextLink = () => { const p = pag(); const last = p && p.querySelector('.pagination__item:last-child a[href]'); return last ? last.href : null; };
    const total = parseInt(status.dataset.total, 10) || 0;
    const btn = $('button', status), txt = $('[data-load-text]', status);
    const count = () => $$('.product-grid > li:not(.vael-grid-promo-item)').length;
    const refresh = () => {
      const p = pag(); if (p) p.style.display = 'none';
      txt.textContent = total ? count() + ' / ' + total + ' ürün gösteriliyor' : '';
      btn.hidden = !nextLink();
    };
    btn.addEventListener('click', async () => {
      const url = nextLink(); if (!url) return;
      btn.classList.add('is-loading'); btn.disabled = true;
      try {
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = $('.product-grid'), newItems = doc.querySelectorAll('.product-grid > li');
        newItems.forEach((li) => grid.appendChild(document.adoptNode(li)));
        const newPag = doc.querySelector('.pagination'), oldPag = pag();
        if (newPag && oldPag) oldPag.replaceWith(newPag); else if (oldPag) oldPag.remove();
        history.replaceState(null, '', url);
        syncWishlistUI();
      } finally { btn.classList.remove('is-loading'); btn.disabled = false; refresh(); }
    });
    refresh();
    const t = $('.product-grid') && $('.product-grid').parentElement;
    t && new MutationObserver(() => requestAnimationFrame(refresh)).observe(t, { childList: true });
  }

  /* ---------------- header wishlist icon ---------------- */
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M12 20.3s-7.6-4.6-9.2-9.4C1.7 7.6 3.9 4.4 7.2 4.4c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.3 0 5.5 3.2 4.4 6.5-1.6 4.8-9.2 9.4-9.2 9.4Z"/></svg>';
  function initHeaderWishlist() {
    $$('header-actions').forEach((ha) => {
      if (ha.querySelector('.vael-header-wishlist')) return;
      const a = document.createElement('a');
      a.href = CFG.wishlistUrl || '/pages/favoriler';
      a.className = 'header-actions__action vael-header-wishlist';
      a.setAttribute('aria-label', 'Favoriler');
      a.innerHTML = HEART + '<span data-wishlist-count="0" aria-hidden="true">0</span>';
      const cart = ha.querySelector('[aria-controls="cart-drawer"], .action__cart');
      cart ? ha.insertBefore(a, cart) : ha.appendChild(a);
    });
  }

  /* ---------------- boot ---------------- */
  function initAll(root = document) {
    initReveal(root); initHero(root); initCarousels(root); initTabs(root); initLooks(root); initPress(root);
    initSizeTables(root); initSiblings(root); initCompleteLook(root); initRecent(root); initNotify(root); initWishlistPage(root);
    syncWishlistUI();
  }
  function boot() {
    trackRecent(); initHeaderWishlist(); initAll(); initMember(); initMenuTags(); initGridPromo(); initLoadMore();
    // keep wishlist hearts in sync when Horizon re-renders cards (filters, sorting, cart morphs)
    let pending = false;
    const IGNORE = '[data-wishlist-count],[data-wishlist-label],[data-vael-toast]';
    new MutationObserver((muts) => {
      if (pending) return;
      if (!muts.some((m) => !(m.target.closest && m.target.closest(IGNORE)))) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; initHeaderWishlist(); syncWishlistUI(); initMenuTags(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  window.VAEL = Object.assign(CFG, { wishlist: { all: wl.all, toggle: wlToggle }, addToCart, openModal });
})();